module.exports = __webpack_public_path__ + "static/media/facebook-icon.1e42c5e1.svg";